export interface MarketPlaceConfig {
  id: string;
  tenantId: string;
  companyName: string;
  publicWebSettings: {
    tenantMarketPlaceIdentifier: string;
    supportedLanguages: string[];
    marketPlaceURLSettings: {
      name: string;
      customName: string;
      isActive: boolean;
      status: string;
      tld: string;
    };
    id: string;
  };
  marketPlaceDesign: {
    logoUrl: string;
    brandColor: string;
    dynamicLandingPageLayout: string;
    heroSectionContent: {
      headerText: string;
      subText: string;
      buttonText: string;
      imageUrl: string;
    };
  };
  platformConfiguration: {
    googleIdentityPlatformReference: string;
    databaseName: string;
    registrationFormId: string;
    enableSignUpForServiceBuyer: boolean;
    serviceBuyerRegistrationFormId: string;
    serviceBuyerSignupWith: {
      phone: boolean;
      email: boolean;
      google: boolean;
      microsoft: boolean;
    };
    companyCode: string;
  };
}

export interface Resources {
  _id: string;
  name: string;
  accessPermission: string;
}

export enum userManagementKey {
  permission = 'PERMISSION',
}
